import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FeedbackHrOneOnOneListPage from './pages/FeedbackHrOneOnOneListPage';
import FeedbackHrOneOnOneDetailPage from './pages/FeedbackHrOneOnOneDetailPage';

const FeedbackHrOneOnOneModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<FeedbackHrOneOnOneListPage />} />
      <Route path="/:applicationId" element={<FeedbackHrOneOnOneDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default FeedbackHrOneOnOneModule;
